import libphonenumber from 'google-libphonenumber';
import {
    AWS_RAW_SOURCE_IMAGE_URL,
    AWS_SOURCE_IMAGE_URL,
    IMAGEKIT_SOURCE_IMAGE_URL,
    leadFormPaths,
} from '../constants/constants';
import moment from 'moment';
import clone from 'lodash/clone';
import isEmpty from 'lodash/isEmpty';
import kebabCase from 'lodash/kebabCase';
import toString from 'lodash/toString';
import capitalize from 'lodash/capitalize';
import _ from 'lodash';

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

export function isValidIndianMobileNo(phone_number) {
    if (!!!phone_number) {
        return false;
    }
    return phone_number.toString().length === 10;
}

export function isValidMobileNo(country_code, phone_number) {
    if (!!!country_code || !!!phone_number) {
        return false;
    }
    const phone = country_code + '' + phone_number;
    return phoneUtil.isValidNumber(phoneUtil.parse(phone));
}

export const generateSessionId = () => {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  };

export function getBrowserName() {
    let isOpera =
        (!!window.opr && !!window.opr.addons) ||
        !!window.opera ||
        navigator.userAgent.indexOf(' OPR/') >= 0;

    // Firefox 1.0+
    let isFirefox = typeof InstallTrigger !== 'undefined';

    // Safari 3.0+ "[object HTMLElementConstructor]"
    let isSafari =
        /constructor/i.test(window.HTMLElement) ||
        (function (p) {
            return p.toString() === '[object SafariRemoteNotification]';
        })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

    // Internet Explorer 6-11
    let isIE = /*@cc_on!@*/ false || !!document.documentMode;

    // Edge 20+
    let isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1 - 71
    let isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    // Edge (based on chromium) detection
    let isEdgeChromium = isChrome && navigator.userAgent.indexOf('Edg') != -1;

    // Blink engine detection
    let isBlink = (isChrome || isOpera) && !!window.CSS;

    if (isOpera) {
        return 'opera';
    } else if (isFirefox) {
        return 'firefox';
    } else if (isSafari) {
        return 'safari';
    } else if (isIE) {
        return 'IE';
    } else if (isEdge) {
        return 'edge';
    } else if (isChrome) {
        return 'chrome';
    } else if (isEdgeChromium) {
        return 'edge-chromium';
    } else if (isBlink) {
        return 'blink';
    } else {
        return 'N/A';
    }
}

export function getNetworkType() {
    if (
        window &&
        window.navigator &&
        window.navigator.connection &&
        window.navigator.connection.effectiveType
    ) {
        return window.navigator.connection.effectiveType;
    } else {
        return 'N/A';
    }
}

export function getOSType() {
    if (window && window.navigator && window.navigator.platform) {
        return window.navigator.platform;
    } else {
        return 'N/A';
    }
}


export function getOS() {
    var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    } else {
        os = 'N/A';
    }

    return os;
}

export function getParameterByNameForUrl(name) {
    let url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getCloudinaryUrl(cloudinaryUrl, height = null, width = null) {
    // https://res.cloudinary.com/demo/image/upload/c_crop,g_face,h_400,w_400/r_max/c_scale,w_200/lady.jpg
    if (cloudinaryUrl) {
        const splitted = cloudinaryUrl.split('upload');
        if (height === null && width === null) {
            const result = `${splitted[0]}upload${splitted[1]}`;
            // const result = `${splitted[0]}upload${'/f_auto'}${splitted[1]}`;
            return result;
        } else {
            if (splitted[1].startsWith('/f_auto')) {
                const replaced = splitted[1].replace(
                    '/f_auto',
                    '/' + 'h_' + height + ',' + 'w_' + width + ',' + 'f_auto'
                );
                return `${splitted[0]}upload${replaced}`;
            } else {
                return `${splitted[0]}upload${'/' + 'h_' + height + ',' + 'w_' + width}${
                    splitted[1]
                }`;
            }
        }
    } else {
        return null;
    }
}

// formatStructure could be auto | svg | jpg | png | gif | webp
// https://ik.imagekit.io/venuemonk/tr:vm360300,f-auto/vm-search-rafiki.svg
// https://venuemonk-images.s3.ap-south-1.amazonaws.com/vm-search-rafiki.svg
export function getImageKitUrl(rawUrl, height = null, width = null, formatStructure = null) {
    if (rawUrl) {
        let newImageKitUrl;
        let POST_HOST_URL;
        const AWS_RAW_URL = AWS_RAW_SOURCE_IMAGE_URL;
        const AWS_CDN_URL = AWS_SOURCE_IMAGE_URL;
        const IMAGEKIT_URL = IMAGEKIT_SOURCE_IMAGE_URL;
        const GUMLET_URL = `https://vmnk.gumlet.io`
        if (rawUrl?.startsWith(AWS_RAW_URL)) {
            newImageKitUrl = rawUrl.replace(AWS_RAW_URL, GUMLET_URL);
            POST_HOST_URL = rawUrl.split(AWS_RAW_URL)[1];
        } else if (rawUrl.startsWith(AWS_CDN_URL)) {
            newImageKitUrl = rawUrl.replace(AWS_CDN_URL, GUMLET_URL);
            POST_HOST_URL = rawUrl.split(AWS_CDN_URL)[1];
        } else if (rawUrl.startsWith(IMAGEKIT_URL)) {
            newImageKitUrl = rawUrl.replace(IMAGEKIT_URL, GUMLET_URL);
            POST_HOST_URL = rawUrl.split(AWS_CDN_URL)[1];
        } else if (rawUrl.startsWith(GUMLET_URL)) {
            newImageKitUrl = rawUrl.replace(GUMLET_URL, GUMLET_URL);
            POST_HOST_URL = rawUrl.split(GUMLET_URL)[1];
        } else {
            return rawUrl;
        }

        if (height === null && width === null) {
            return newImageKitUrl;
        }  else if (height !== null && width !== null) {
            // tr:w-300,h-360
            return `${GUMLET_URL}${POST_HOST_URL}?h=${height}&w=${width}`;
            // return `${IMAGEKIT_URL}/tr:vm${height}${width}${POST_HOST_URL}`;
        } else {
            return `${GUMLET_URL}${POST_HOST_URL}?w=${width}&h=${height}`;
            // return `${IMAGEKIT_URL}/tr:vm${height}${width},f-${formatStructure}${POST_HOST_URL}`;
        }
    } else {
        return null;
    }
}

export function getImageProcessingUrl(rawUrl, options = {}) {
    if (!rawUrl) {
        return null;
    }

    const imageServiceUrl = `https://vmnk.gumlet.io`;
    const urlWithoutService = rawUrl.replace(/^https?:\/\/[^/]+/, ''); 
    const processedUrl = `${imageServiceUrl}${urlWithoutService}`;

    const parsedUrl = new URL(processedUrl);
if(!isEmpty(options)){
    for (const [key, value] of Object.entries(options)) {
        parsedUrl.searchParams.set(key, value);
    }
}
 

    return parsedUrl.toString();
}

export function tranformCommentImage(imageKitUrl, url, height = null, width = null) {
    if (height === null && width === null) {
        return `${imageKitUrl}${url}`;
    } else {
        return `${imageKitUrl}${url}?w=${width}&h=${height}`;
    }
}

function rand(min, max) {
    const random = Math.random();
    return Math.floor(random * (max - min) + min);
}

export function createOTP(num) {
    const length = num || 4;
    const allowsChars = '0123456789';
    let password = '';
    for (let index = 0; index < length; ++index) {
        const charIndex = rand(0, allowsChars.length - 1);
        password += allowsChars[charIndex];
    }
    return password;
}

export function createQueryString(query) {
    if (_.isEmpty(query)) {
        return '';
    } else {
        const queryParams = Object(query);
        const qString = [];
        if (queryParams) {
            for (let key in queryParams) {
                if (queryParams[key] !== void 0) {
                    let encodedParam;
                    if (Array.isArray(queryParams[key]) && queryParams[key].length) {
                        for (let i = 0; i < queryParams[key].length; i++) {
                            encodedParam = encodeURIComponent(String(queryParams[key][i]).trim());
                            qString.push(key + '=' + encodedParam);
                        }
                    } else {
                        encodedParam = encodeURIComponent(String(queryParams[key]).trim());
                        qString.push(key + '=' + encodedParam);
                    }
                }
            }
            return '?' + qString.join('&');
        }
    }
}

export function formatContactNo(contactNo) {
    if (contactNo && contactNo.length > 10) {
        return contactNo.replace('91', '').replace('+91', '');
    } else {
        return contactNo;
    }
}

export function aggregatedmediashow(media,file){
  return media && media.filter(
        (item) => file(item.fileType)
    );
}

export function isFileImage(filetype) {
    return filetype && filetype.split('/')[0] === 'image';
}

export function isFileVideo(filetype) {
    return filetype && filetype.split('/')[0] === 'video';
}

export function validatePhoneNumber(phone) {
    return (
        phone &&
        phone.toString().length === 10 &&
        parseInt(phone).toString().length === phone.toString().length &&
        (phone.startsWith('6') ||
            phone.startsWith('7') ||
            phone.startsWith('8') ||
            phone.startsWith('9'))
    );
}

export function isHTML(str) {
    return !(str || '')
        .replace(/<([^>]+?)([^>]*?)>(.*?)<\/\1>/gi, '')
        .replace(/(<([^>]+)>)/gi, '')
        .trim();
}

export function convertToHtml(value, style) {
    if (isHTML(value)) {
        return value;
    } else {
        return `<p style=${style}>${value}</p>`;
    }
}

export const getCurrentMonth = () => {
    const monthNum = moment().month() + 1;
    return moment(monthNum, 'M').format('MMMM');
};

export const windowPushState = (data, unused, url) => {
    window.history.pushState(data, unused, url);
};

export const getDateMappedForAvailability = (dateSelected) => {
    const date = new Date(dateSelected);
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
};

export const sortTheList = (a, b, key, type) => {
    if (type === 'asc') {
        return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
    } else {
        return a[key] > b[key] ? -1 : a[key] > b[key] ? 1 : 0;
    }
};

export const buildUrl = (url, options) => {
    let queryString = [];
    let key;
    let builtUrl;

    if (url === null) {
        builtUrl = '';
    } else if (typeof url === 'object') {
        builtUrl = '';
        options = url;
    } else {
        builtUrl = url;
    }
    if (options) {
        if (options.path) {
            builtUrl += '/' + options.path;
        }
        if (options.queryParams) {
            for (key in options.queryParams) {
                if (Object.prototype.hasOwnProperty.call(options.queryParams, key)) {
                    queryString.push(key + '=' + options.queryParams[key]);
                }
            }
            builtUrl += '?' + queryString.join('&');
        }

        if (options.hash) {
            builtUrl += '#' + options.hash;
        }
    }
    return builtUrl;
};

export const pluralize = (count, noun, suffix = 's') => `${noun}${count !== 1 ? suffix : ''}`;

export const removeSearchQuery = (query) => {

    if (query !== null && query != undefined) {
        let newQuery = clone(query);
        delete newQuery.url;
        delete newQuery.cityslug;
        return newQuery;
    } else {
        return query;
    }
};

export const getSortFilter = () => {
    return [
        {
            value: 'pricing-asc',
            label: 'Price: Low to High',
        },
        {
            value: 'pricing-dsc',
            label: 'Price: High to Low',
        },
        {
            value: 'rating-asc',
            label: 'Rating: Low to High',
        },
        {
            value: 'rating-dsc',
            label: 'Rating: High to Low',
        },
        {
            value: 'capacity-asc',
            label: 'Capacity: Low to High',
        },
        {
            value: 'capacity-dsc',
            label: 'Capacity: High to Low',
        },
    ];
};

export const getPhotographerSortFilter = () => {
    return [
        {
            value: 'pricing-asc',
            label: 'Price: Low to High',
        },
        {
            value: 'pricing-dsc',
            label: 'Price: High to Low',
        },
        {
            value: 'rating-asc',
            label: 'Rating: Low to High',
        },
        {
            value: 'rating-dsc',
            label: 'Rating: High to Low',
        },
    ];
};

export const changeQueryToString = (query) => {
    // {service_type: pre-wedding}
    let qString = '';
    if (query !== null && query !== undefined) {
        let newQuery = clone(query);
        delete newQuery.url;
        delete newQuery.cityslug;
        if (newQuery && newQuery !={}) {
            // let qstring
            // for (const [key, value] of Object.entries(newQuery)) {
            //   qstring = qstring.concat(`${key}=${value}`);
            // }
            let quString = Object.entries(newQuery)
                .map(([key, val]) => `${key}=${val}`)
                .join('&');
            qString = '?' + quString;
            // qString = new URLSearchParams(newQuery).toString();
            // qString = '?' + qString;
            // qString ='?' + Object.keys(newQuery).map(key => {
            // return `${key}=${encodeURIComponent(newQuery[key])}`;}).join('&');
        }
    } else {
        qString = '';
    }
    return qString;
};

export const getSearchFormattedDate = (date) => {
    return date ? moment(new Date(date)).format('MMM DD') : moment(new Date()).format('MMM DD');
};

export const getMidFilterSearchImage = (key) => {
    let url = '';
    if (key) {
        if (key === 'occasions') {
            url = 'vm_purplegroup_icon';
        }
        if (key === 'packagetypes') {
            url = 'vm_food_icon';
        }
        if (key === 'price') {
            url = 'vm_moneycalculator_icon';
        }
        if (key === 'capacity') {
            url = 'vm_guestcapacity_icon';
        }
        if (key === 'venuetypes') {
            url = 'vm_purplehouse_icon';
        }
        if (key === 'localities') {
            url = 'vm_purplelocation_icon';
        }
        return `${url}`;
    } else {
        return `_`;
    }
};

export const removeDuplicateElements = (events) => {
    let newEvents = [];
    for (let i = 0; i < events.length; i++) {
        let flag = 0;
        if (events[i]) {
            for (let j = i + 1; j < events.length; j++) {
                if (events[i] === events[j]) {
                    flag = 1;
                    break;
                }
            }
            if (flag === 0) {
                newEvents.push(events[i]);
            }
        }
    }
    return newEvents;
};

export const removeBlankKeys = (object) => {
    let newObject = {};
    for (let prop in object) {
        if (!isEmpty(object[prop])) {
            if (Array.isArray(object[prop])) {
                newObject[prop] = removeDuplicateElements(object[prop]);
            } else {
                newObject[prop] = object[prop];
            }
        }
    }
    return newObject;
};

export const IS_PRODUCTION = process.env.NEXT_PUBLIC_STAGE === 'production';

export const getVenueUrlTitle = (venue) => {
    return {
        overview: {
            url: `/venues/${venue?.city_slug}/${venue?.vm_id}`,
            title: 'Overview',
        },
        photos: {
            url: `/venues/${venue.city_slug}/${venue.vm_id}/photos`,
            title: 'Photos',
        },
        packages: {
            url: `/venues/${venue.city_slug}/${venue.vm_id}/packages-and-menus`,
            // title: `${venue.packageCount > 0 ? venue.packageCount : ''} Packages`
            title: `Packages`,
        },
        reviews: {
            url: `/venues/${venue.city_slug}/${venue.vm_id}/reviews`,
            // title: `${venue.reviewCount > 1 ? venue.reviewCount : ''} ${pluralize(venue.reviewCount, 'Review')}`
            title: `${pluralize(venue.reviewCount, 'Review')}`,
        },
        brochure: {
            url: `/venues/${venue.city_slug}/${venue.vm_id}/brochures`,
            // title: `${venue.reviewCount > 1 ? venue.reviewCount : ''} ${pluralize(venue.reviewCount, 'Review')}`
            title: `Brochures`,
        },
        qna: {
            url: `/venues/${venue.city_slug}/${venue.vm_id}/questions-and-answers`,
            title: 'Q&A',
        },
    };
};

export const getVendorUrlTitle = (vendor,route="photographer") => {
    return {
        overview: {
            url: `/${route}/${vendor?.url}`,
            title: 'Overview',
        },
        photos: {
            url: `/${route}/${vendor?.url}/photos`,
            title: 'Photos',
        },
        packages: {
            url: `/${route}/${vendor?.url}/packages-and-menus`,
            // title: `${venue.packageCount > 0 ? venue.packageCount : ''} Packages`
            title: `Packages`,
        },
        reviews: {
            url: `/${route}/${vendor?.url}/reviews`,
            // title: `${venue.reviewCount > 1 ? venue.reviewCount : ''} ${pluralize(venue.reviewCount, 'Review')}`
            // title: `${pluralize(venue.reviewCount, 'Review')}`,
            title: 'Reviews',
        },
        qna: {
            url: `/${route}/${vendor?.url}/question-and-answers`,
            title: 'Q&A',
        },
    };
};

export const makeUrlValid = (value) => toString(kebabCase(value?.toLowerCase()));

export const isDataNullOrEmpty = (data) => data == null || data == undefined || isEmpty(data);

export const isDataNotNullAndUndefined = (data) => data !== null && data !== undefined;

export const getUrlWithOutQueryString = (url) => {
    if (isDataNotNullAndUndefined(url)) {
        const splittedUrl = url.split('?');
        if (splittedUrl?.length > 0) {
            return splittedUrl[0];
        } else {
            return url;
        }
    } else {
        return url;
    }
};

export const masonaryEffectGallery = (colCount, colIndex, itemIndex) => {
    let imgIndx;
    imgIndx = itemIndex * colCount + colIndex + 1;
    return imgIndx - 1;
};

export const hasWhiteSpace = (s) => {
    return /\s/g.test(s);
};

export const checkIfDataIsImage = (file) => {
    return file?.split('/').includes('images');
};

export const checkMediaTypeForEditReview = (editingState, item) => {
    if (!editingState) {
        return item.mediaType === 'images';
    } else if (editingState) {
        return item.fileType.split('/')[0] === 'image';
    }
};

export const getCtaColor = (city) => {
    let color = '';

    switch (city) {
        case 'bangalore':
            color = '#58BF93';
            break;
        default:
            color = '#491369';
            break;
    }

    return color;
};

export const getVendorCtaColor = (city) => {
    let color = '';

    switch (city) {
        case 'bangalore':
            color = '#58BF93';
            break;
        default:
            color = '#BE0456';
            break;
    }

    return color;
};

export const getCtaText = (city, month) => {
    let ctaText = '';

    switch (city) {
        case 'bangalore':
            ctaText = 'Get free food tasting';
            break;
        default:
            ctaText = `Check ${getCurrentMonth()} offers`;
            break;
    }

    return ctaText;
};

export const getVendorCtaText = (month) => {
    let ctaText = '';
    ctaText = `Book now`;
    return ctaText
}


export const redirectToHomePage = () => {
    localStorage.setItem('redirect', 'redirectToHomePage')
}

export const checkArray = (array) => {
    if (array.length > 0) {
        return array
    } else {
        return []
    }
}

export const replaceiFrame = (str) => {
    let result
    if (str.includes('iframe')) {
        result = str.replace(/<iframe.*<\/iframe>/g, '');
    }
    return result;
}

export function camelToNormal(camelCaseString) {
    const normalString = camelCaseString.replace(/([A-Z])/g, ' $1');
    return capitalize(normalString.trim());
  }

export function fetchVendorKeyFromUrl(router){
    try {
        let type;
        type = router.split('/')[2]
        let vendorType = type.split("?")[0]
        return vendorType ? vendorType : type;
    }
    catch(e){

    }
}

export function convertFileSize(bytes) {
    let size = bytes;
    let unit = 'B';

    switch (true) {
        case bytes >= 1073741824:
            size = (bytes / 1073741824).toFixed(2);
            unit = 'GB';
            break;
        case bytes >= 1048576 :
            size = (bytes / 1048576).toFixed(2);
            unit = 'MB';
            break;
        case bytes >= 1024:
            size = (bytes / 1024).toFixed(2);
            unit = 'KB';
            break;
        default:
            size = bytes.toFixed(2);
    }

    return size + ' ' + unit;
}

export function generateMessageId(length) {
    let loopLength = length || 8;
    let allowsChars = '0123456789';
    let password = '';
    for (let index = 0; index < loopLength; ++index) {
        let charIndex = rand(0, allowsChars.length - 1);
        password += allowsChars[charIndex];
    }
    return password;
};

export function formatCustomDate(inputDate) {
    const dateObject = new Date(inputDate);

    const months = [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'
    ];

    const day = dateObject.getDate();
    const monthIndex = dateObject.getMonth();
    const month = months[monthIndex];
    const year = dateObject.getFullYear();

    const formattedDate = `${day} ${month}, ${year}`;

    return formattedDate;
}


export const replacePlaceholders = (text, replacements) => {
    let result = text;
    for (const [placeholder, value] of Object.entries(replacements)) {
      const pattern = new RegExp(`\\{${placeholder}\\}`, 'g');
      result = result.replace(pattern, value);
    }
    return result;
  };

export const getOperationalTime = (startTime, endTime) => {
    if ((checkValidTime(startTime,'h:mma','h A'), checkValidTime(endTime,'h:mma','h A')))
        return `${formatTime(startTime,'h:mma','h A')} - ${formatTime(endTime,'h:mma','h A')}`;
};


export const formatTime = (time,timeformat,toFormat) => {
    if (!time || moment(time, timeformat).format(toFormat) == 'Invalid date') {
        return '';
    }
    return moment(time, timeformat).format(toFormat);
};

export const checkValidTime = (time,timeformat,toFormat) => {
    if (moment(time,timeformat ).format(toFormat) == 'Invalid date') {
        return false;
    }
    return true;
};

function getCurrentPath() {
    const currentPath = window.location.pathname;
    return currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath;
}
  


export const checkIfLeadFormPage =()=>{
    if(leadFormPaths.includes(getCurrentPath())){
        return true
    }
    return false
}

export function buildnewUrl(baseUrl, queryParams) {
    try{
        const parsedUrl = new URL(baseUrl);

        if (queryParams && Object.keys(queryParams).length > 0) {
            for (const [key, value] of Object.entries(queryParams)) {
                parsedUrl.searchParams.set(encodeURIComponent(key), encodeURIComponent(value));
            }
        }
        return parsedUrl.toString();
    }
    catch(e){
        return baseUrl
    }
  
}

export function getBasePath  (route){ 
        if(!route.includes("?")){
            return route
        }
       let baseRoute = route.split("?")
        return  baseRoute[0]
}

export function addHoursandMinuteToDate(hours, minutes) {
    return moment()
        .startOf('day')
        .add(hours, 'hours')
        .add(minutes, 'minutes');
}

export function convertTimeTo24HourFormat(time, isEndDate = false) {
    const [hour, minute, period] = time.split(/:|(?=[ap]m)/);
    let hourInt = parseInt(hour, 10);
    let minuteInt = parseInt(minute, 10);

    if (isEndDate && period === 'am' && hourInt < 10) {
        hourInt += 24;
    } else if (period === 'pm' && hour !== '12') {
        hourInt += 12;
    } else if (period === 'am' && hour === '12') {
        hourInt = 0;
    }

    return { hour: hourInt, minute: minuteInt };
}



